"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("_");

var _loggers = require("customer-data-tracking/loggers");

var _once = _interopRequireDefault(require("transmute/once"));

var _BackboneHistoryLogging = _interopRequireDefault(require("crm_internal/usage/BackboneHistoryLogging"));

var _hubspotTracking = _interopRequireDefault(require("crm_internal/utils/hubspotTracking"));

var _TrackingEvents = _interopRequireDefault(require("crm_internal/config/TrackingEvents"));

var _TrackingPixelUtils = _interopRequireDefault(require("tracking-pixels/TrackingPixelUtils"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _localSettings = _interopRequireDefault(require("crm_internal/config/localSettings"));

var _setupTools = _interopRequireDefault(require("hublabs-experiments/setup/setupTools"));

var _FulcrumJS = _interopRequireDefault(require("FulcrumJS.fulcrum"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var setup = (0, _once.default)(function () {
  _BackboneHistoryLogging.default.init();

  var splitRoute = window.location.pathname.split("/" + _hubspot.default.get() + "/");
  var appName = splitRoute.length > 1 && splitRoute[1] === 'lists' ? 'lists' : 'crm';

  _FulcrumJS.default.getCreateDates();

  _setupTools.default.registerUser(_hubspot.default.get());

  (0, _.defer)(function () {
    if (!appName === 'lists') {
      _loggers.CrmLogger.log('index-interaction', {
        action: 'crm pageload'
      });
    }

    if (_localSettings.default.get(_TrackingEvents.default.HUBSPOT.CRM_ACTIVATED.localSetting)) {
      _TrackingPixelUtils.default.trackActiveUser();
    }

    var backgroundImage = _localSettings.default.get('backgroundImage') || '';

    if (_localSettings.default.get('CRM:BackgroundImages') && backgroundImage !== '') {
      document.body.style.background = "url('" + backgroundImage + "')";
    }

    if (appName !== 'lists') {
      (0, _hubspotTracking.default)(_TrackingEvents.default.SIDEKICK.USED_CRM_DATE);
      (0, _hubspotTracking.default)(_TrackingEvents.default.HUBSPOT.USED_CRM_DATE);
    }

    if (window.location.href.indexOf('via=crm-setup') !== -1) {
      var didSignup = _localSettings.default.get(_TrackingEvents.default.HUBSPOT.FINISHED_SIGNUP_FLOW.localSetting);

      if (!didSignup) {
        (0, _hubspotTracking.default)(_TrackingEvents.default.HUBSPOT.FINISHED_SIGNUP_FLOW);
      }
    }

    var scopes = _ScopesContainer.default.getContainer().get() || {};

    if (scopes['salesaccelerator-access']) {
      (0, _hubspotTracking.default)(_TrackingEvents.default.SIDEKICK.USED_ACCELERATOR_DATE);
    }
  });
});
var _default = setup;
exports.default = _default;
module.exports = exports.default;